import React from 'react';
import { DataList, createInitialFilters } from 'commons-ui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { activeFilter, columnConfigs } from './listConfig';

const ConfigList: React.FC<{}> = () => {
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList);
	const actions = getActionList();
	const { getTDSConfigData, tdsOfferSegmentsData } = useService();
	if (actions?.addAction) actions.addAction.tdsOfferSegmentsData = tdsOfferSegmentsData;
	actions.rowActions[1].tdsOfferSegmentsData = tdsOfferSegmentsData;
	return (
		<div>
			<DataList
				fetchData={getTDSConfigData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.TDS_CONFIGS}
				initialFilters={createInitialFilters(activeFilter)}
				initialSortDirection='ASC'
				initialSortIndex={1}
			/>
		</div>
	);
};

export default ConfigList;
